import { NavLink, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

const navLinks = [
  { to: '/queue', label: 'Queue', end: true },
  { to: '/active', label: 'Active Dropships', end: false },
  { to: '/reports', label: 'Reports', end: false },
  { to: '/visibility', label: 'Visibility', end: false },
  { to: '/settings', label: 'Settings', end: false },
  { to: '/health', label: 'Health', end: false },
  { to: '/audit', label: 'Audit', end: false },
]

export function Layout() {
  const user = useAuthStore((s) => s.user)
  const logout = useAuthStore((s) => s.logout)

  return (
    <div className="min-h-screen">
      <header className="flex items-center gap-4 border-b border-gray-200 px-4 py-2">
        <span className="text-sm font-bold tracking-wide uppercase">KH Dropship</span>
        <nav className="flex flex-1 gap-1">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              className={({ isActive }) =>
                `px-3 py-1 text-sm ${isActive ? 'font-semibold text-black' : 'text-gray-500 hover:text-black'}`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
        <span className="text-xs text-gray-500">{user?.username}</span>
        <button
          type="button"
          onClick={() => void logout()}
          className="text-xs text-gray-500 hover:text-black"
        >
          Sign out
        </button>
      </header>
      <main className="p-4">
        <Outlet />
      </main>
    </div>
  )
}
